<script>
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';

  let mounted = false;
  
  onMount(() => {
    mounted = true;
  });
</script>

<nav class="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm border-b border-gray-100">
  <div class="container mx-auto">
    <div class="h-20 flex items-center">
      <div class="w-full flex justify-center sm:justify-start">
        <!-- Logo -->
        {#if mounted}
          <a 
            href="/" 
            class="text-sm sm:text-md logo text-black hover:text-black/70 transition-colors"
            in:fade={{ duration: 800, delay: 200 }}
          >
            Jonas Loh | Design for Decisions
          </a>
        {/if}
      </div>
    </div>
  </div>
</nav>


<style>
  .logo {
    font-family: 'Simple-Regular', monospace;
    letter-spacing: -0.01em;
  }

  nav {
    min-height: fit-content;
  }
</style>
